import { AnnouncementBar } from "../components/AnnouncementBar";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { UspStrip } from "../components/UspStrip";
import { Collection } from "../components/Collection";
import { PackagingShowcase } from "../components/PackagingShowcase";
import { ThreeDShowcase } from "../components/ThreeDShowcase";
import { Craftsmanship } from "../components/Craftsmanship";
import { WearThreeWays } from "../components/WearThreeWays";
import { Reels } from "../components/Reels";
import { About } from "../components/About";
import { Newsletter } from "../components/Newsletter";
import { Footer } from "../components/Footer";
import { StickyMobileCTA } from "../components/StickyMobileCTA";

export function HomePage() {
  return (
    <div className="bg-[#F4EDE2] text-[#0C111C]" data-testid="yaba-homepage">
      <AnnouncementBar />
      <Nav />
      <Hero />
      <UspStrip />
      <Collection />
      <PackagingShowcase />
      <ThreeDShowcase />
      <Craftsmanship />
      <WearThreeWays />
      <Reels />
      <About />
      <Newsletter />
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
